<template>
  <v-dialog
    v-model="shown"
    fullscreen
    hide-overlay
    transition="fade-transition"
    content-class="media-lightbox"
  >
    <div class="media-lightbox__root">
      <div class="media-lightbox__bar">
        <span class="media-lightbox__counter">{{ index + 1 }} / {{ items.length }}</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          dark
          large
          class="media-lightbox__close"
          :aria-label="$t('custom.close')"
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-carousel
        v-model="index"
        class="media-lightbox__carousel"
        hide-delimiters
        :continuous="false"
        :show-arrows="items.length > 1"
        :show-arrows-on-hover="false"
      >
        <v-carousel-item v-for="(item, i) in items" :key="`${item.src}-${i}`">
          <div class="media-lightbox__slide">
            <!-- Формат, который браузер не показывает (HEIC/TIFF в Chrome, битая ссылка), —
                 ссылка на сам файл вместо пустого чёрного экрана -->
            <div v-if="failed[i]" class="media-lightbox__fallback">
              <v-icon dark x-large>mdi-file-alert-outline</v-icon>
              <v-btn
                class="mt-4"
                color="primary"
                :href="item.src"
                target="_blank"
                rel="noopener"
              >
                {{ $t("analitics.download") }}
              </v-btn>
            </div>
            <!-- src без <source type>: Chrome на canPlayType("video/quicktime") отвечает "",
                 и .mov с iPhone с объявленным типом не играл бы вовсе; по src браузер
                 определяет контейнер сам. touchstart.stop: перемотка не листает карусель -->
            <video
              v-else-if="item.type === 'video'"
              ref="videos"
              class="media-lightbox__media"
              :src="item.src"
              controls
              playsinline
              preload="metadata"
              @touchstart.stop
              @error="markFailed(i)"
            ></video>
            <img
              v-else
              class="media-lightbox__media"
              :src="item.src"
              alt=""
              @error="markFailed(i)"
            />
          </div>
        </v-carousel-item>
      </v-carousel>
    </div>
  </v-dialog>
</template>

<script>
// Полноэкранный просмотр фото и видео галерей бронирования/авто.
// Заменил vue-it-bigger: та задавала видео фиксированные 800×600 px (на телефоне
// кадр обрезался с обеих сторон), а крестик ставила в top:0 под статус-бар
// (viewport-fit=cover) и прятала через 3 с бездействия.
//
// items: [{ type: "image" | "video", src, contentType }]; открытие — open(index).
export default {
  name: "MediaLightbox",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      shown: false,
      index: 0,
      failed: {},
    };
  },
  watch: {
    items() {
      this.failed = {};
    },
    index() {
      this.pauseVideos();
    },
    shown(value) {
      if (value) {
        window.addEventListener("keydown", this.onKeydown);
      } else {
        window.removeEventListener("keydown", this.onKeydown);
        this.pauseVideos();
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    open(index) {
      if (!this.items[index]) return;
      this.index = index;
      this.shown = true;
    },
    close() {
      this.shown = false;
    },
    prev() {
      if (this.index > 0) this.index -= 1;
    },
    next() {
      if (this.index < this.items.length - 1) this.index += 1;
    },
    markFailed(i) {
      this.$set(this.failed, i, true);
    },
    onKeydown(event) {
      if (event.key === "ArrowLeft") this.prev();
      if (event.key === "ArrowRight") this.next();
    },
    pauseVideos() {
      (this.$refs.videos || []).forEach((video) => video.pause());
    },
  },
};
</script>

<style>
.media-lightbox {
  background: #000;
}

.media-lightbox__root {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #000;
  outline: none;
}

.media-lightbox__bar {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  padding: calc(env(safe-area-inset-top, 0px) + 4px) 8px 4px 16px;
  color: #fff;
}

.media-lightbox__carousel.v-carousel {
  flex: 1 1 auto;
  height: auto !important;
  min-height: 0;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.media-lightbox__carousel .v-window__container,
.media-lightbox__carousel .v-window-item,
.media-lightbox__carousel .v-carousel__item {
  height: 100% !important;
}

.media-lightbox__slide {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.media-lightbox__fallback {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.media-lightbox__media {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>
